import * as yup from "yup";

export function getLicenceValidation() {
  return yup.object({
    name: yup.string().max(120, 'Licence name is too long').required('Name is required'),
    technologyId: yup.number().min(1, 'Technology is required'),
    responsiblePeople: yup.array(yup.number()),
    issueDate: yup.date().typeError('Should be a valid date').nullable().transform((curr, orig) => (orig === '' ? null : curr)),
    expirationDate: yup.date().typeError('Should be a valid date').nullable().transform((curr, orig) => (orig === '' ? null : curr)).min(yup.ref('issueDate'), 'Expiration date cannot be before Issue date'),
    notifyInDays: yup.number().max(180, 'Duration is too big').integer('Should be an integer number').min(0, 'Cannot be negative'),
    description: yup.string(),
  })
}